'use client';
import React from 'react';
import moment from 'moment';
import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { PlansDealBannerProps } from '../../types/plans';
import ExpiredDealBanner from './ExpiredDealBanner';
import ActiveDealBanner from './ActiveDealBanner';
import ExpiredDealBannerContent from './ExpireadDealBannerContent';

type Props = {
  plansPage: PlansDealBannerProps;
};

/**
 * DealBanner.
 */
const DealBanner: React.FC<Props> = ({ plansPage }): JSX.Element => {
  const { deal, dealExpired, dealPaused } = plansPage;

  const currentDate = moment();
  const expirationDate = moment(deal?.expires);
  const isExpired =
    !!dealExpired || !!dealPaused || expirationDate <= currentDate;

  return (
    <Box data-testid="deal-banner-container">
      <Flex className="items-center justify-center text-center">
        {!deal || isExpired ? (
          <ExpiredDealBanner deal={deal} />
        ) : (
          <ActiveDealBanner plansPage={plansPage} />
        )}
      </Flex>
      {isExpired && <ExpiredDealBannerContent />}
    </Box>
  );
};
export default DealBanner;
